module.exports = __webpack_public_path__ + "static/media/about-us-icon.6849bf16.svg";